import { c as _c } from "react/compiler-runtime";
import { BulkChangeCompanyRole } from "@components/table/members/bulk-actions/bulk-change-company-role";
import { BulkSeats } from "@components/table/members/bulk-actions/bulk-seats";
import { BulkAddToTeam } from "@components/table/members/bulk-actions/bulk-add-to-team";
import { BulkExportMembers } from "@components/table/members/bulk-actions/bulk-export-members";
import { BulkRemoveMember } from "@components/table/members/bulk-actions/bulk-remove-member";
import { BulkResendInvitation } from "@components/table/members/bulk-actions/bulk-resend-invitation";
import { BulkSendEmail } from "@components/table/members/bulk-actions/bulk-send-email";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { useMemberSeatsLookup } from "@hooks/use-member-seats-lookup";
import { useShouldShowBulkAction } from "@hooks/table/use-should-show-bulk-action";
import { useAppSelector } from "@store/store-helper";
import { fetchingMembersFlagsSelector } from "@store/members/members-selector";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { useMemo } from "react";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/** List all the bulk action components for company member table */
export function useCompanyMemberBulkActions(t0) {
  const $ = _c(49);
  const {
    members,
    company
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("members");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const {
    isFetchingCompanyMembers
  } = useAppSelector(fetchingMembersFlagsSelector);
  const isAnyRowSelected = selectedEntities.length !== 0;
  let t2;
  if ($[1] !== selectedEntities) {
    t2 = selectedEntities.some(_temp);
    $[1] = selectedEntities;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isAnyMemberPending = t2;
  const {
    canEditMember,
    canDeleteMemberFromCompany,
    canResendInvitationToCompany,
    canManageSceneLicenses,
    canManageXgSeats
  } = useHasUserValidRoleCompanyLevel();
  const {
    canInviteMembersToTeam
  } = useTeamsAccess();
  const {
    isActiveSeatPlan,
    hasSceneSeats
  } = useMemberSeatsLookup();
  const canChangeSeatsInBulk = isActiveSeatPlan && canManageXgSeats || hasSceneSeats && canManageSceneLicenses;
  let allowedButtons;
  if ($[3] !== canChangeSeatsInBulk || $[4] !== canDeleteMemberFromCompany || $[5] !== canEditMember || $[6] !== canInviteMembersToTeam || $[7] !== canResendInvitationToCompany || $[8] !== isAnyMemberPending || $[9] !== isAnyRowSelected) {
    allowedButtons = ["export"];
    if (isAnyRowSelected) {
      allowedButtons.push("sendEmail");
      if (canEditMember) {
        allowedButtons.push("changeRole");
      }
      if (canChangeSeatsInBulk) {
        allowedButtons.push("seats");
      }
      if (canInviteMembersToTeam) {
        allowedButtons.push("addToTeam");
      }
      if (isAnyMemberPending && canResendInvitationToCompany) {
        allowedButtons.push("resendInvitation");
      }
      if (canDeleteMemberFromCompany) {
        allowedButtons.push("removeMember");
      }
    }
    $[3] = canChangeSeatsInBulk;
    $[4] = canDeleteMemberFromCompany;
    $[5] = canEditMember;
    $[6] = canInviteMembersToTeam;
    $[7] = canResendInvitationToCompany;
    $[8] = isAnyMemberPending;
    $[9] = isAnyRowSelected;
    $[10] = allowedButtons;
  } else {
    allowedButtons = $[10];
  }
  const allowedButtonsBasedOnRowSelection = allowedButtons;
  let t3;
  if ($[11] !== allowedButtonsBasedOnRowSelection) {
    t3 = {
      allowedButtonsBasedOnRowSelection
    };
    $[11] = allowedButtonsBasedOnRowSelection;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const {
    shouldShowBulkButtons
  } = useShouldShowBulkAction(t3);
  let t4;
  if ($[13] !== isFetchingCompanyMembers || $[14] !== members || $[15] !== shouldShowBulkButtons) {
    t4 = shouldShowBulkButtons("export") && (isFetchingCompanyMembers || members.length > 0);
    $[13] = isFetchingCompanyMembers;
    $[14] = members;
    $[15] = shouldShowBulkButtons;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const shouldShowExportButton = t4;
  if (!company) {
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        changeRole: null,
        seats: null,
        addToTeam: null,
        resendInvitation: null,
        removeMember: null,
        sendEmail: null,
        export: null
      };
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    return t5;
  }
  let t5;
  if ($[18] !== company || $[19] !== shouldShowBulkButtons) {
    t5 = shouldShowBulkButtons("changeRole") ? <BulkChangeCompanyRole companyId={company.id} entityType="members" /> : null;
    $[18] = company;
    $[19] = shouldShowBulkButtons;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== shouldShowBulkButtons) {
    t6 = shouldShowBulkButtons("seats") ? <BulkSeats /> : null;
    $[21] = shouldShowBulkButtons;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== shouldShowBulkButtons) {
    t7 = shouldShowBulkButtons("addToTeam") ? <BulkAddToTeam /> : null;
    $[23] = shouldShowBulkButtons;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== company || $[26] !== selectedEntities || $[27] !== shouldShowBulkButtons) {
    t8 = shouldShowBulkButtons("resendInvitation") ? <BulkResendInvitation selectedEntities={selectedEntities} companyId={company.id} subjectType="workspace" /> : null;
    $[25] = company;
    $[26] = selectedEntities;
    $[27] = shouldShowBulkButtons;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== company || $[30] !== shouldShowBulkButtons) {
    t9 = shouldShowBulkButtons("removeMember") ? <BulkRemoveMember subjectType="workspace" companyId={company.id} /> : null;
    $[29] = company;
    $[30] = shouldShowBulkButtons;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== selectedEntities || $[33] !== shouldShowBulkButtons) {
    t10 = shouldShowBulkButtons("sendEmail") ? <BulkSendEmail selectedEntities={selectedEntities} /> : null;
    $[32] = selectedEntities;
    $[33] = shouldShowBulkButtons;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== company || $[36] !== isAnyRowSelected || $[37] !== members || $[38] !== selectedEntities || $[39] !== shouldShowExportButton) {
    t11 = shouldShowExportButton ? <BulkExportMembers selectedEntities={isAnyRowSelected ? selectedEntities : members} subjectType="workspace" entityName={company.name} areEntitiesSelected={isAnyRowSelected} /> : null;
    $[35] = company;
    $[36] = isAnyRowSelected;
    $[37] = members;
    $[38] = selectedEntities;
    $[39] = shouldShowExportButton;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== t10 || $[42] !== t11 || $[43] !== t5 || $[44] !== t6 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t12 = {
      changeRole: t5,
      seats: t6,
      addToTeam: t7,
      resendInvitation: t8,
      removeMember: t9,
      sendEmail: t10,
      export: t11
    };
    $[41] = t10;
    $[42] = t11;
    $[43] = t5;
    $[44] = t6;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  return t12;
}
function _temp(member) {
  return !FaroCoreApiUtils.Member.isMemberActive(member);
}